(ns app.front.dev.fsm
  (:require [cljs.pprint]
            [core.front.carbon :as cc]
            [core.front.event :refer [>evt]]
            [re-frame.core-instrumented :as rf]
            [tilakone.core :as tk]
            [tilakone.util :as tku]))

(defn all-current-signals
  "Returns all transition signals from current fsm state."
  [fsm]
  (->> (tku/state fsm (::tk/state fsm))
       ::tk/transitions
       (map ::tk/on)))

(defn current-guard-results
  "Returns results from guards as map, where key is the signal for transition and value a collection of [state guards-result]
  tuples where state is possible state with the signal and guards-result is a boolean indicating if that state transition
  is allowed by guards."
  ([fsm]
   (current-guard-results fsm (all-current-signals fsm)))
  ([fsm signals]
   (->> signals
        (map #(vector % (tk/apply-guards fsm %)))
        (map (fn [[signal transition-results]]
               [signal (->> transition-results
                            (map (fn [[transition guards]]
                                   [(::tk/to transition) (->> guards
                                                              (map ::tk/allow?)
                                                              (every? true?))])))]))
        (into {}))))

(defn possible-transitions
  "Returns vector of tuples ([signal state]), where signals have truthy from the result of `current-guard-results`."
  ([fsm]
   (possible-transitions fsm (all-current-signals fsm)))
  ([fsm all-signals]
   (->> (current-guard-results fsm all-signals)
        (reduce
          (fn [acc [signal transitions]]
            (concat acc (->> transitions
                             (filter second)
                             (map #(vector signal (first %))))))
          []))))

(rf/reg-event-db
  ::apply-signal
  (fn [db [_ signal]]
    (update db ::fsm tk/apply-signal signal)))


(rf/reg-sub
  ::fsm
  #(-> % ::fsm))


(rf/reg-sub
  ::all-signals
  :<- [::fsm]
  :-> all-current-signals)


(rf/reg-sub
  ::possible-next-states
  :<- [::fsm]
  :<- [::all-signals]
  (fn [[fsm all-signals] _]
    (possible-transitions fsm all-signals)))


;;
;; reference you FSM here:
;;
(rf/reg-event-db
  ::setup-fsm
  (fn [db [_ fsm]]
    (assoc db ::fsm fsm)))


(defn fsm [fsm-model]
  (>evt [::setup-fsm fsm-model])
  (let [fsm                  (rf/subscribe [::fsm])
        all-signals          (rf/subscribe [::all-signals])
        possible-next-states (rf/subscribe [::possible-next-states])]
    (fn [_]
      [:div
       [:h1.my-4 "Run your FSM"]
       [:section.p-8
        (if-not @fsm
          [:p.text-support-01 "No FSM set, check your state!"]
          [:div
           [:button.my-4 {:on-click #(>evt [::setup-fsm fsm-model])} "Reset FSM state"]
           [:p "Current state:"]
           [:pre.my-4.text-base
            (with-out-str (cljs.pprint/pprint (->> @fsm
                                                   (remove (fn [[_k v]] (fn? v)))
                                                   (remove (fn [[k _v]] (= k ::tk/states)))
                                                   (into {}))))]
           (cc/accordion
             {}
             (cc/accordion-item
               {:title "Possible signals"
                :open  true}
               (into
                 [:ul]
                 (for [[signal new-state] @possible-next-states]
                   [:li.py-2.my-2
                    (str signal " -> " new-state)
                    [:button
                     {:on-click #(>evt [::apply-signal signal])}
                     "Apply signal"]])))
             (cc/accordion-item
               {:title "All signals"
                :open  true}
               (into
                 [:ul]
                 (for [signal @all-signals]
                   [:li
                    {:class-name (if (some #(= signal (first %)) @possible-next-states)
                                   "py-2 my-2 text-support-02"
                                   "py-2 my-2 text-support-01")}
                    [:pre (pr-str signal)]])))
             (cc/accordion-item
               {:title "Raw FSM data"}
               [:pre (with-out-str (cljs.pprint/pprint (->> @fsm
                                                            (remove (fn [[_k v]] (fn? v)))
                                                            (into {}))))]))])]])))
